var _defs, _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconRequestReason(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 18,
    viewBox: "0 0 20 18"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".icon_request_reason_svg__a{fill:#f45c85;fill-rule:evenodd}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "icon_request_reason_svg__a",
    d: "M9.61 1.577C4.279-3.9-9.049 5.682 9.61 18z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "icon_request_reason_svg__a",
    d: "M10 3.3l-.9-.884a4.8 4.8 0 00-7.35 1.247c-.654 1.228-.8 3 .393 5.262C3.293 11.1 5.686 13.712 10 16.553c4.315-2.842 6.706-5.451 7.858-7.628 1.194-2.263 1.047-4.035.393-5.262A4.8 4.8 0 0010.9 2.412zM10 18C-9.166 5.841 4.1-3.648 9.781 1.372c.075.066.149.134.22.205q.106-.106.22-.2C15.9-3.651 29.167 5.84 10 18z"
  })));
}

export default SvgIconRequestReason;